import { Suspense, useState } from 'react'
import { ISection } from '../../models/ISection'
import FallBackImage from './FallBackImage';
import Link from 'next/link';
import { ILocalizedParams } from '../../models/ICommon';
import HomepageSwiper from '../HomepageSwiper';


export default function HomepageBanner({ locale, posts, targetTitle, targetType, targetId, targetSlug, title, showTitle, automated, device, eager, ...rest }: ILocalizedParams<ISection> & {device?: string}) {
  const [selected, setSelected] = useState(0);
  const item = posts[selected];

  if (!item) return null;

  return (
    <div className='flex flex-col h-[calc(80vh-71px)] tablet:h-[unset] tablet:aspect-[16/9] desktop:aspect-[unset] w-full mb-[60px]'>
      <Link className='h-full relative tablet:aspect-[16/9]' href={`/${!automated || targetType === 1 ? item.category.uniqueCode : targetSlug}/${item.uniqueCode}`} hrefLang={locale} title={item.title}>
        <div className='flex flex-col relative justify-end h-full px-[35px] py-[16px]'>
        <FallBackImage key={item.image} thumbnail={item.thumbnail} src={item.image} eager fill sizes='100vw' alt={item.imageAlt || ''} className='absolute top-0 left-0 h-full object-cover' />
          <div className='absolute bottom-0 left-0 h-[85%] tablet:h-[40%] w-full bg-gradient-banner dark:bg-gradient-banner-dark' />
          <div className='flex flex-col gap-y-[20px]'>
            {showTitle ? <h2 className='tag h4 font-medium tablet:font-kufi-600'>{`جديد فوشيا`}</h2> : null}
            {item.title ? <span className='text-white h1 desktop:max-w-[85%]'>{item.title}</span> : null}
          </div>
        </div>
      </Link>

      <div className='flex items-center justify-center gap-x-[30px] h-[150px] bg-primary-300 dark:bg-night-100 py-[24px] desktop:rounded-br-[12px] desktop:rounded-bl-[12px]'>
        <Suspense fallback={<></>}>
          <HomepageSwiper
            device={device}
            selected={selected}
            locale={locale}
            data={{
              targetType,
              automated,
              posts,
              category: {
                title: targetTitle || '',
                targetSlug
              }
            }}
            setSelected={(idx: number) => setSelected(idx)}
          />
        </Suspense>
      </div>
    </div>
  )
}